commusoftCommon.filter('expiryDate', function (CS_LANGUAGE) {
    return function (dateString) {
        if (dateString == '') {
            return '';
        }
        moment.locale(CS_LANGUAGE);
        return moment(dateString).format('MM/YY')
    };
});